import React, { useEffect, useState } from "react";
import Mapir from "mapir-react-component";
import { getDeliverLocaApi } from "../../Api/SupplierServices";
// import { getDeliverLocaApi } from "../../Api/ClientServices";

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ",
        "Mapir-SDK": "reactjs",
      },
    };
  },
  dragRotate:false,
});
export default function LiveLocationMap(props) {
  const [center, setCenter] = useState([36.431987, 52.386548]);
  const [markerArray, setMarkerArray] = useState([]);

  const MINUTE_MS = 6000;
  useEffect(() => {
    const interval = setInterval(() => {
      getLocation();
    }, MINUTE_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLocation = async () => {
    const result = await getDeliverLocaApi(props.orderId);
    mapClickHandler(result);
  };
  function mapClickHandler(e) {
    setCenter([e.location.lon, e.location.lat]);
    // setZoom(9)
    localStorage.setItem("checkMarker", true);
    reverseFunction(e);
  }

  function reverseFunction(e) {
    var url = `https://map.ir/reverse/no?lon=${e.location.lon}&lat=${e.location.lat}`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6Ijg3MzUwNWY0NmMwM2I1M2NiYzU1ZDdhNzIwN2Y4OWM0NDJlYzNhNzEzYTM3YmUxZDg3YmZhN2UzODI5YWNkYzIyMGYyYWQ3ZmU3ZDBlZWY0IiwiaWF0IjoxNjQ5NjY5MTQ5LCJuYmYiOjE2NDk2NjkxNDksImV4cCI6MTY1MDcwNTk0OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.QtGGJZjSmZZYG_sss24KJ8XjqiWorsya-emnAMHMX2iaKZEK9Uw_IMmRU3EZFqpSo0r-ueXxFs4EcT9WJobwyMafHnHjTC9yBcICHjh-imGWqjuyE5Xr487-ZAAWuQ1GvT4gTRxFdfMUFDe0wsjY8eNmqYPkcfslJnsyWgUO_GcZsg_xnWpyRdJbPaWWDEr9if1SpjGGEXSmQjWU-psCCwy2wIB4CL1xLvMrT3mHBqx2mp7RrO82gOVD9obnZYGjIXDBa9v1CCqnbjhkqOVDW4_kcnC8UNdHsNvdnRXhJEV3eIhdmEJzIX9IG1DwfC3cpm_a8xm_NzQK-g27lWfHJQ",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // localStorage.setItem('lon',data.geom.coordinates[1])
        // localStorage.setItem('lat',data.geom.coordinates[0])
        //   localStorage.setItem('address_compact',data.address_compact)
      });
    const array = [];
    array.push(
      <Mapir.Marker
        style={{ width: "2.5rem" }}
        coordinates={[e.location.lon, e.location.lat]}
        Image={"Assets/Images/map/marker1.png"}
        // degree={`rotate(${parseInt(e.location.bearing)}deg)`}
        key={0}
        
      />
    );
    setMarkerArray(array);
  }
  return (
    <>
      <div>
        <Mapir center={center} zoom={[13]} Map={Map}>
          {markerArray}
        </Mapir>
      </div>
    </>
  );
}
